// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaDetailsBase, CriteriaDetailsBaseSchema } from 'api/gen/CriteriaDetailsBase';

const requiredPart = t.interface({
  tag: t.literal('SINGLE_INT'),
  value: t.union([t.Integer, t.null]),
});

export const SingleIntegerCriteriaDetailsSchema = excess(t.intersection([CriteriaDetailsBaseSchema.type, requiredPart]));

export interface SingleIntegerCriteriaDetails extends t.TypeOf<typeof SingleIntegerCriteriaDetailsSchema> {}
